/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateSmsTfaOptionErrorResponse,
  CreateSmsTfaOptionRequest,
  CreateSmsTfaOptionResponse,
} from './api.schemas';

import { api } from '../util/http';

export const tfaSms = (
  createSmsTfaOptionRequest: CreateSmsTfaOptionRequest,
  signal?: AbortSignal,
) => {
  return api<CreateSmsTfaOptionResponse>({
    url: `/api/auth/tfa/sms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSmsTfaOptionRequest,
    signal,
  });
};

export const getTfaSmsMutationOptions = <
  TError = CreateSmsTfaOptionErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tfaSms>>,
    TError,
    { data: CreateSmsTfaOptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tfaSms>>,
  TError,
  { data: CreateSmsTfaOptionRequest },
  TContext
> => {
  const mutationKey = ['tfaSms'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tfaSms>>,
    { data: CreateSmsTfaOptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return tfaSms(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaSmsMutationResult = NonNullable<Awaited<ReturnType<typeof tfaSms>>>;
export type TfaSmsMutationBody = CreateSmsTfaOptionRequest;
export type TfaSmsMutationError = CreateSmsTfaOptionErrorResponse;

export const useTfaSms = <TError = CreateSmsTfaOptionErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tfaSms>>,
      TError,
      { data: CreateSmsTfaOptionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tfaSms>>,
  TError,
  { data: CreateSmsTfaOptionRequest },
  TContext
> => {
  const mutationOptions = getTfaSmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
